import {
  GET_ALL,
  GET_ALL_FAILURE,
  GET_ALL_SUCCESS,
  ADD,
  ADD_FAILURE,
  ADD_SUCCESS,
  DELETE,
  DELETE_FAILURE,
  DELETE_SUCCESS,
  EDIT,
  EDIT_FAILURE,
  EDIT_SUCCESS,
  GET,
  GET_FAILURE,
  GET_SUCCESS,
} from "./actionTypes";

//actions types for DemoStore

export const getAllDemoStores = (payload) => {
  return {
    type: GET_ALL,
    payload: payload,
  };
};

export const getAllDemoStoresSuccess = (payload) => {
  return {
    type: GET_ALL_SUCCESS,
    payload: payload,
  };
};

export const getAllDemoStoresFailure = (error) => {
  return {
    type: GET_ALL_FAILURE,
    payload: error,
  };
};

export const addDemoStore = (payload) => {
  return {
    type: ADD,
    payload: payload,
  };
};
export const addDemoStoreSuccess = (payload) => {
  return {
    type: ADD_SUCCESS,
    payload: payload,
  };
};

export const addDemoStoreFailure = (error) => {
  return {
    type: ADD_FAILURE,
    payload: error,
  };
};

export const getDemoStore = (payload) => {
  return {
    type: GET,
    payload: payload,
  };
};
export const getDemoStoreSuccess = (payload) => {
  return {
    type: GET_SUCCESS,
    payload: payload,
  };
};

export const getDemoStoreFailure = (error) => {
  return {
    type: GET_FAILURE,
    payload: error,
  };
};

export const editDemoStore = (payload) => {
  return {
    type: EDIT,
    payload: payload,
  };
};
export const editDemoStoreSuccess = (payload) => {
  return {
    type: EDIT_SUCCESS,
    payload: payload,
  };
};

export const editDemoStoreFailure = (error) => {
  return {
    type: EDIT_FAILURE,
    payload: error,
  };
};

export const deleteDemoStore = (payload) => {
  return {
    type: DELETE,
    payload: payload,
  };
};

export const deleteDemoStoreSuccess = (payload) => {
  return {
    type: DELETE_SUCCESS,
    payload: payload,
  };
};

export const deleteDemoStoreFailure = (error) => {
  return {
    type: DELETE_FAILURE,
    payload: error,
  };
};
